import { render, staticRenderFns } from "./BulkMessageInput.vue?vue&type=template&id=12169aef&scoped=true&"
import script from "./BulkMessageInput.vue?vue&type=script&lang=js&"
export * from "./BulkMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./BulkMessageInput.vue?vue&type=style&index=0&id=12169aef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12169aef",
  null
  
)

export default component.exports